import React from "react";
import "./Home.css";
import Banner from "../../Banner/Banner";
import TreasuryBalance from "../../TreasuryBalance/TreasuryBalance";
import RealTimedata from "../../RealtimeData/RealTimedata";
import TreasureOverview from "../../TreasuryBalance/TreasureOverview";
import InvestmentsTreasury from "../Investments/InvestmentsTreasury";
import TreasuryAllocation from "../TreasuryAllocations/TreasuryAllocation";
import Audio from "../../../common/Audio";
const Home = () => {
  return (
    <div className="">
      <Banner />
      <TreasuryBalance />
      {/* <RealTimedata /> */}
      <TreasuryAllocation />
      <InvestmentsTreasury />
      <TreasureOverview />
      <Audio />
    </div>
  );
};

export default Home;
